import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_ALL_PAYMENT,
  FILTER_PAYMENT,
  UPDATE_PAYMENT,
  CREATE_PAYMENT,
  UPDATE_BULK
} from 'constants/payments.constants'
import axios from 'axios'
import {
  fetchPaymentsSuccess,
  filterPaymentsSuccess,
  updatePaymentSuccess,
  createPaymentSuccess,
  updateBulkSuccess
} from "actions/payments.action";
import { showErrors, stopLoader, setNotification } from "actions/general.action";
import { userSignOut } from "actions/auth.action";

const fetchPaymentRequest = async (page) => {
  return axios.get('/api/v1/super_admin/payment?page=' + page);
}

function* fetchPayments({ payload }) {
  try {
    const reuslt = yield call(fetchPaymentRequest, payload);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      yield put(fetchPaymentsSuccess(reuslt.data));
      yield put(stopLoader())
    }
  } catch (error) {
    yield put(showErrors(error));
    // ask about best practices for this
    (error.response.statusText === "Unauthorized") && (yield put(userSignOut()));
  }
}

const updatePaymentRequest = async (payload) => {
  let s = Object.assign({}, payload);
  return axios.put('/api/v1/super_admin/payment/' + payload.id,
    s
  );
}

function* updatePayment({ payload }) {
  try {
    const reuslt = yield call(updatePaymentRequest, payload);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      yield put(updatePaymentSuccess(reuslt.data));
      yield put(stopLoader())
    }
  } catch (error) {
    yield put(showErrors(error));
    (error.response.statusText === "Unauthorized") && (yield put(userSignOut()));
  }
}

const updateBulkPaymentRequest = async (payload) => {
  const { ids, query, search_key, search_value, select_all_status, unchecked_payment_list } = payload;
  let new_payload = {
    ids: ids,
    query: query,
    select_all_status: false,
  }
  if (select_all_status) {
    new_payload = {
      query: query,
      select_all_status: true,
      search_key: search_key,
      search_value: search_value,
      unchecked_payment_list: unchecked_payment_list
    }
  }
  return axios.put('/api/v1/super_admin/payment', new_payload);
}

function* bulkUpdatePayment({ payload }) {
  try {
    const reuslt = yield call(updateBulkPaymentRequest, payload);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      yield put(updateBulkSuccess(reuslt.data));
      yield put(stopLoader())
    }
  } catch (error) {
    yield put(showErrors(error));
    (error.response.statusText === "Unauthorized") && (yield put(userSignOut()));
  }
}

const createPaymentRequest = async (payload) => {
  let s = Object.assign({}, payload);
  
  delete s.id;
  delete s.payment_id;
  
  return axios.post('/api/v1/super_admin/payment',
    s
  );
}

function* createPayment({ payload }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  }
  try {
    const result = yield call(createPaymentRequest, payload);
    if (result.message) {
      notification.status = "error";
      notification.message = result.message;
    } else {
      notification.status = "success";
      notification.message = "Payment Created";
      yield put(createPaymentSuccess(result.data));
    }
    yield put(stopLoader());
    yield put(setNotification(notification));
  } catch (error) {
    notification.status = "error";
    if (error.response.data.message != undefined) {
      notification.message = error.response.data.message;
    } else {
      notification.message = error.message;
    }
    yield put(stopLoader());
    yield put(setNotification(notification));
    (error.response.statusText === "Unauthorized") && (yield put(userSignOut()));
  }
}

const filterPaymentsRequest = async (payload) => {
  let link = '/api/v1/super_admin/payment?key=' + payload.key + '&value=' + payload.value + "&page=" + payload.page;
  if(payload.key === "date_range") {
    link = '/api/v1/super_admin/payment?key=' + payload.key + '&start_date=' + payload.date_range[0] + '&end_date=' + payload.date_range[1] + "&page=" + payload.page
  }else {
    if(payload.date_range[0] && payload.date_range[1]) { // if not null
      link = '/api/v1/super_admin/payment?key=' + payload.key + '&value=' + payload.value + '&start_date=' + payload.date_range[0] + '&end_date=' + payload.date_range[1] + "&page=" + payload.page
    }
  }
  return axios.get(link);
};



function* filterPayments({ payload }) {
  try {
    const result = yield call(filterPaymentsRequest, payload);

    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(filterPaymentsSuccess(result.data));
      yield put(stopLoader());
    }
  } catch (error) {
    yield put(showErrors(error.message));
    (error.response.statusText === "Unauthorized") && (yield put(userSignOut()));
  }
}

export function* forkFetchPayments() {
  yield takeEvery(FETCH_ALL_PAYMENT, fetchPayments);
}


export function* forkFilterPayments() {
  yield takeEvery(FILTER_PAYMENT, filterPayments);
}

export function* forkUpdatePayment() {
  yield takeEvery(UPDATE_PAYMENT, updatePayment);
}

export function* forkBulkUpdatePayment() {
  yield takeEvery(UPDATE_BULK, bulkUpdatePayment);
}

export function* forkCreatePayment() {
  yield takeEvery(CREATE_PAYMENT, createPayment);
}


export default function* rootSaga() {
  yield all([
    fork(forkFetchPayments),
    fork(forkFilterPayments),
    fork(forkUpdatePayment),
    fork(forkCreatePayment),
    fork(forkBulkUpdatePayment)
  ]);
}